<template>
  <div class="mall-footer">
    <div class="content">
      <h2>鸿联商城期待您的加入</h2>
      <p>
        面对产业智能化机遇与挑战，鸿联创与生态伙伴共建国产化智能新生态，携手打造数字化转型与智能化升级的一站式产品、方案和服务，让产业智能化更简单。
      </p>
      <!-- <div class="btn" @click="$router.push('/login')">立即加入 <a-icon type="right" /></div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "mallFooter",
};
</script>

<style scoped lang="scss">
.mall-footer {
  width: 100%;
  height: 240px;
  background: url("../../../assets/img/2.0/mall/homeBg3.png") no-repeat;
  background-size: cover;
  .content {
    width: 1280px;
    margin: 0 auto;
    padding: 60px 0;
    > h2 {
      font-weight: 500;
      font-size: 32px;
      color: #ffffff;
      line-height: 44px;
      margin-bottom: 32px;
    }
    > p {
      font-size: 16px;
      line-height: 22px;
      color: #fff;
      opacity: 0.9;
    }
    .btn {
      width: 156px;
      height: 44px;
      border: 1px solid #ffffff;
      cursor: pointer;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 42px;
      text-align: center;
    }
  }
}
</style>
